import React, { type FC } from 'react';

import {
    FooterLayout,
    ScrollableCalendar,
    type CalendarProps,
} from '@eventbrite/timed-entry';

import {
    DateEventStatus,
    type DateAvailabilityStatus,
} from '../../../state/infiniteCalendarSeries';
import styles from './CalendarContainer.module.scss';
import { calendarDateCellProps, footerSignals } from './CalendarProps';

type CalendarContainerProps = Required<
    Pick<
        CalendarProps<DateAvailabilityStatus>,
        | 'onMonthLoad'
        | 'onDateSelect'
        | 'initialSelectedDate'
        | 'locale'
        | 'firstMonth'
        | 'lastMonth'
        | 'calendarData'
    >
>;

export const CalendarContainer: FC<CalendarContainerProps> = ({
    calendarData,
    onMonthLoad,
    initialSelectedDate,
    locale,
    firstMonth,
    lastMonth,
    onDateSelect,
}) => {
    return (
        <>
            <ScrollableCalendar
                dateCellProps={calendarDateCellProps}
                calendarData={calendarData}
                initialSelectedDate={initialSelectedDate}
                locale={locale}
                firstMonth={firstMonth}
                lastMonth={lastMonth}
                onMonthLoad={onMonthLoad}
                onDateSelect={onDateSelect}
                defaultDateCellKey={DateEventStatus.unavailable}
            />
            <div className={styles.footerLayout}>
                <FooterLayout footerMetaData={footerSignals} />
            </div>
        </>
    );
};
